import React, { Fragment, useEffect, useRef, useState } from 'react';
import { HeaderImg, StyledHeader, MenuWrapper, ExtraDiv, HeaderContent } from '@components/Header/Header.styled';
import { CodingConstants, UIConstants } from '@constants';
import Link from '@components/Link/Link';
import { HeaderProps, MainMenuOptions } from '@types';
import { accessTokenObj } from '@utils/auth.config';
import RoundIcon from '@components/Header/RoundIcon';
import MenuOptions from '@components/MenuOptions/MenuOptions';
import HamBurgerIcon from '@components/Header/HamBurgerIcon';
import { useDetectOutsideClick } from '@hooks/useDetectOutsideClick';
import { useDispatch, useSelector } from 'react-redux';
import { selectHasFullAppFlow } from '@store/selectors/fullApp.selector';
import { setShowFullAppExitModal } from '@store/actions/fullApp.action';
import { selectedAccountLoanType } from '@store/selectors/widgets.selectors';
import { getmenuOptions } from '@utils/filterMenuOptions';

const Header: React.FC<HeaderProps> = ({ loanOptions, getOption, name, menuOptions, loanType, content }: HeaderProps) => {
    const accessToken: any = accessTokenObj();
    const dispatch = useDispatch();
    const hasFullAppFlow: boolean = useSelector(selectHasFullAppFlow);
    const accountLoanType = useSelector(selectedAccountLoanType);
    const onClickEagle = () => {
        if (hasFullAppFlow) {
            dispatch(setShowFullAppExitModal(true));
        } else {
            const options = loanOptions?.filter(option => option.type == CodingConstants.servicingLoanType);
            if (options && options.length > 0) getOption(options[0]);
        }
    };
    const { servicingLoanType, inProgressLoanType, servicingType } = CodingConstants;
    const servicingLoan = content === servicingLoanType ? true : false;

    const [mainMenuOptions, setMainMenuOptions] = useState([]);
    const dropdownRef = useRef(null);

    const [isSubMenuActive, setIsSubMenuActive] = useDetectOutsideClick(dropdownRef, false);

    useEffect(() => {
        const filteredOptions = getmenuOptions(menuOptions, content, accountLoanType);
        setMainMenuOptions(filteredOptions);
    }, [content, menuOptions, accountLoanType]);

    return (
        <StyledHeader id="headerMain">
            <HeaderContent>
                <input type="hidden" id="UserUUID" name="UserUUID" value={accessToken?.uuid} />
                <HamBurgerIcon
                    menuOptions={menuOptions}
                    content={content}
                    name={name}
                    loanType={loanType}
                    isActive={isSubMenuActive}
                    setIsActive={setIsSubMenuActive}
                />
                <Link id="eagleIcon" data-testid="eagleIcon" onClick={onClickEagle}>
                    <HeaderImg src={UIConstants.icons.eagleIcon} />
                </Link>
                <MenuWrapper>
                    {mainMenuOptions?.map(menu => (
                        <Fragment key={menu.id}>
                            {(servicingLoan || content === 'escrow') && (
                                <>
                                    {menu.id === 'Loan_Information' && (
                                        <MenuOptions
                                            heading={menu.name}
                                            menuOptions={menu.subMenuOptions}
                                            loanType={loanType}
                                            subMenuClick={() => setIsSubMenuActive(false)}
                                        />
                                    )}
                                    {menu.id === 'Payment_Center' && (
                                        <MenuOptions
                                            heading={menu.name}
                                            menuOptions={menu.subMenuOptions}
                                            subMenuClick={() => setIsSubMenuActive(false)}
                                        />
                                    )}
                                    {menu.id === 'Document' && (
                                        <MenuOptions
                                            heading={menu.name}
                                            menuOptions={menu.subMenuOptions}
                                            subMenuClick={() => setIsSubMenuActive(false)}
                                        />
                                    )}
                                </>
                            )}
                            {menu.id === 'Support' && (
                                <MenuOptions
                                    heading={menu.name}
                                    menuOptions={menu.subMenuOptions}
                                    loanType={loanType}
                                    subMenuClick={() => setIsSubMenuActive(false)}
                                />
                            )}
                            {menu.id === 'Profile' && <RoundIcon userName={name} menuOptions={menu.subMenuOptions} />}
                            {menu.id === 'logout_url' && (
                                <MenuOptions heading={menu.name} url={menu.url} subMenuClick={() => setIsSubMenuActive(false)} />
                            )}
                        </Fragment>
                    ))}
                </MenuWrapper>
                <ExtraDiv />
            </HeaderContent>
        </StyledHeader>
    );
};

export default Header;
